import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "../lib/api";
import axios from "axios";
import { Star, Loader2, Quote } from "lucide-react";

function Stars({ value, size = "w-4 h-4" }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`${size} ${i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
      ))}
    </div>
  );
}

export default function WidgetReviews() {
  const { companyId } = useParams();
  const [data, setData] = useState(null);
  const [idx, setIdx] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    document.title = "Avis clients";
    axios.get(`${API}/public/directory/${companyId}`).then((r) => setData(r.data)).catch(() => setData(false));
  }, [companyId]);

  useEffect(() => {
    if (!data || !data.reviews?.length) return;
    timer.current = setInterval(() => setIdx((i) => (i + 1) % data.reviews.length), 4500);
    return () => clearInterval(timer.current);
  }, [data]);

  if (data === false) return <div className="p-6 text-slate-500 text-sm">Avis indisponibles.</div>;
  if (!data) return <div className="p-6 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-sky-500" /></div>;

  const rev = data.reviews?.[idx];
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4" data-testid="widget-reviews">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 p-6 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-3xl font-display font-bold text-navy">{data.aggregate.global || "—"}<span className="text-base text-slate-400">/5</span></div>
            <Stars value={data.aggregate.global} size="w-5 h-5" />
          </div>
          <div className="text-right">
            <div className="text-sm font-semibold text-navy">{data.company.name}</div>
            <div className="text-xs text-slate-500">{data.aggregate.count} avis vérifiés</div>
          </div>
        </div>
        {rev && (
          <div className="mt-5 border-t border-slate-100 pt-4 min-h-[110px]" data-testid="widget-review-card">
            <Quote className="w-5 h-5 text-sky-400" />
            <p className="text-sm text-slate-600 mt-1 leading-relaxed line-clamp-3">{rev.comment || "Client satisfait."}</p>
            <div className="flex items-center justify-between mt-3">
              <span className="text-sm font-medium text-navy">{rev.client_name}</span>
              <Stars value={rev.global} />
            </div>
          </div>
        )}
        {data.reviews?.length > 1 && (
          <div className="flex justify-center gap-1.5 mt-4">
            {data.reviews.map((_, i) => (
              <button key={i} onClick={() => setIdx(i)} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-5 bg-sky-400" : "w-1.5 bg-slate-200"}`} />
            ))}
          </div>
        )}
        <a href={`${window.location.origin}/annuaire/${companyId}`} target="_blank" rel="noreferrer"
          className="mt-4 block text-center text-xs text-sky-600 font-semibold hover:underline">Voir tous les avis →</a>
      </div>
    </div>
  );
}
